module.exports = __webpack_public_path__ + "img/purchase-incentive.5f4c4758.png";